type Props = {
  end: string;
  formattedEnd: string;
  start: string;
  formattedStart: string;
};

export default function DateDisplay({
  end,
  formattedEnd,
  start,
  formattedStart,
}: Props) {
  return (
    <>
      <span className="sr-only">start date</span>{" "}
      <time dateTime={start}>{formattedStart}</time> <span aria-hidden>–</span>{" "}
      <span className="sr-only">end date</span>{" "}
      <time dateTime={end}>{formattedEnd}</time>
    </>
  );
}
